import { AppliedDiscountCode } from 'modules/benefitCodes'
import { Cart,CartItem } from 'modules/cart'
import { CustomerTypes } from 'modules/customer'
import { TMSDeliverySlotData,TMSReservationSlotData } from 'modules/delivery'
import { Promotion } from 'modules/products'
import { Price } from 'shared/types/price'

import { PaymentMethod } from './submodules/payment/types'

interface TimeSlot {
  date: string
  start: string
  end: string
}

export interface Receipt {
  createdAt: string
  fakturowniaId?: string
  documentUrl: string
  invoiceNumber?: string
  ereceiptUrl: string
  id: string
  receiptToken: string
  saleOrderId: string
  sellerId: string
  updatedAt: string
}

export interface Invoice {
  createdAt: string
  fakturowniaId: string
  ereceiptUrl?: string
  id: string
  invoiceNumber: string
  saleOrderId: string
  sellerId: string
  updatedAt: string
  viewUrl: string
}

export type SaleOrderProcessingStatus =
  | 'paid'
  | 'new'
  | 'accepted'
  | 'in_delivery'
  | 'delivered'
  | 'cancelled'
  | 'awaiting_payment'
  | 'not_delivered'
  | 'in_progress'
  | 'partially_paid'

interface SaleOrderBase {
  //todo remove unused fields
  id: string
  cartId: string
  status: SaleOrderProcessingStatus
  returnStatus: SaleOrderReturnStatus
  onlinePaymentRequired: boolean
  paymentLink: string | null
  paidAt: string | null
  isEligibleForFreeDelivery: boolean
  isEditable: boolean
  editableUntil?: string
  edited: boolean
  requestsInvoice: boolean
  invoiceName: string
  invoiceNip: string
  invoiceCity: string
  invoiceStreet: string
  invoicePostalCode: string
  invoiceHouseNumber: string
  invoiceFlatNumber: string
  isInvoiceIssued: boolean
  code: string
  totalValueNet: Price
  paymentValue: Price
  totalValueVat: Price
  totalValueGross: Price
  deliveryCostNet: Price
  deliveryCostGross: Price
  deliveryCostVatAmount: Price
  customerId: string
  distributionCenterId: string
  paymentMethodId: string
  deliverySlotId: string
  deliveryFrom: string
  deliveryTo: string
  deliveryAddressName: string
  deliveryAddressCity: string
  deliveryAddressPostalCode: string
  deliveryAddressStreet: string
  deliveryAddressHouseNumber: string
  deliveryAddressFlatNumber: string
  deliveryAddressFloor: number
  deliveryAddressBuildingName: string | null
  deliveryAddressPhoneNumber: string
  updatedAt: string
  createdAt: string
  discountCodes: AppliedDiscountCode[]
  distributionCenter: object
  paymentMethod: PaymentMethod
  deliverySlot: TimeSlot
  items: CartItem[]
  editPaymentDifference: {
    type: 'payment' | 'refund'
    value: Price
  }
  // if tms is on tmsReservationSlotData is exist
  // if it is off tmsDeliverySlot is exist
  tmsReservationSlotData: TMSReservationSlotData
  tmsDeliverySlot: TMSDeliverySlotData
  //
}

export interface PlacedSaleOrder extends SaleOrderBase {
  promotions: Promotion
  cart: Cart
  customer: CustomerTypes
}

export interface SaleOrder extends SaleOrderBase {
  receipts: Receipt[]
  invoices: Invoice[]
  tmsReservationSlotData: TMSReservationSlotData
}

export interface SaleOrdersMeta {
  lastPage: number
  currentPage: number
  total: number
}

export interface SaleOrderResponse {
  data: {
    data: SaleOrder[]
    meta: SaleOrdersMeta
  }
}

export interface SingleSaleOrderResponse {
  data: {
    data: SaleOrder
  }
}

// ---------------------------------------------------------------------------
// Order return
// ---------------------------------------------------------------------------

export enum SaleOrderReturnStatus {
  UNAVAILABLE = 'unavailable',
  AVAILABLE = 'available',
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected'
}

export interface SaleOrderReturnRequestBody {
  items: {
    id: string
    quantity: number
  }[]
  reasonNote?: string
}
